import { createContext, useContext, useState, useEffect, useCallback, useRef } from 'react';
import api from '../services/api';
import { useAuth } from './AuthContext';

const CartContext = createContext();
export const useCart = () => useContext(CartContext);

export function CartProvider({ children }) {
  const { user } = useAuth();
  const [cart, setCart] = useState({ items: [], total: 0 });
  const userRef = useRef(user);

  useEffect(() => { userRef.current = user; }, [user]);

  const fetchCart = useCallback(async () => {
    if (!localStorage.getItem('access')) {
      setCart({ items: [], total: 0 });
      return;
    }
    try {
      const { data } = await api.get('cart/');
      setCart(data);
    } catch (e) {
      console.error('Cart fetch error:', e);
    }
  }, []);

  useEffect(() => {
    fetchCart();
  }, [user, fetchCart]);

  const addToCart = async (variant, quantity = 1) => {
    try {
      const { data } = await api.post('cart/', { variant, quantity });
      setCart(data);
      return data;
    } catch (e) {
      console.error('Add to cart error:', e);
      throw e;
    }
  };

  const updateItem = async (item_id, quantity) => {
    const { data } = await api.put('cart/', { item_id, quantity });
    setCart(data);
  };

  const removeItem = async (item_id) => {
    const { data } = await api.delete(`cart/?item_id=${item_id}`);
    setCart(data);
  };

  const clearCart = async () => {
    const { data } = await api.delete('cart/');
    setCart(data);
  };

  const cartCount = cart.items?.reduce((sum, i) => sum + i.quantity, 0) || 0;

  return (
    <CartContext.Provider value={{ cart, addToCart, updateItem, removeItem, clearCart, cartCount, fetchCart }}>
      {children}
    </CartContext.Provider>
  );
}
